

function Loader() {
    return (
        <div className="loader-wrapper-hbtreal">
            <div className="spinner-hbtreal"></div>
            <p className="loader-text-hbtreal">Loading, Please Wait...</p>
        </div>
    )
}


export default Loader;